var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddVideoAlternate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16222_37196",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16222_37196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 27H19.5C19.925 27 20.2812 26.8563 20.5687 26.5688C20.8562 26.2813 21 25.925 21 25.5V24L24 25.575V19.425L21 21V19.5C21 19.075 20.8562 18.7188 20.5687 18.4313C20.2812 18.1438 19.925 18 19.5 18H13.5C13.075 18 12.7187 18.1438 12.4312 18.4313C12.1437 18.7188 12 19.075 12 19.5V25.5C12 25.925 12.1437 26.2813 12.4312 26.5688C12.7187 26.8563 13.075 27 13.5 27ZM9 33C8.175 33 7.46875 32.7063 6.88125 32.1188C6.29375 31.5313 6 30.825 6 30V6C6 5.175 6.29375 4.46875 6.88125 3.88125C7.46875 3.29375 8.175 3 9 3H21L30 12V30C30 30.825 29.7062 31.5313 29.1187 32.1188C28.5312 32.7063 27.825 33 27 33H9ZM19.5 13.5V6H9V30H27V13.5H19.5Z",
    fill: "#767676"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVideoAlternate);
export default __webpack_public_path__ + "static/media/AddVideoAlternate.26e99c54b0bac0ff24219e3387ea8fa6.svg";
export { ForwardRef as ReactComponent };